import { createContext } from 'react'

const PageLoadContext = createContext(false)

export default PageLoadContext
